export const LOAD_TEMPLATE_DROPDOWN_TEST_ID = 'load-template-dropdown-menu';
